import { useTheme } from '@automata/mui-theme';
import { KeyValuePair, Typography } from '@automata/ui';
import { secondsToDurationString } from '@automata/utils/time';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';

type Props = {
  estimatedRuntime: number;
  batches: number | null;
};

const PreviewMetrics = ({ estimatedRuntime, batches }: Props) => {
  const theme = useTheme();
  const formattedTime = secondsToDurationString(estimatedRuntime, true);
  return (
    <Stack
      direction="row"
      borderRadius={1}
      bgcolor={theme.palette.primary['50']}
    >
      {batches && (
        <>
          <Box p={2}>
            <KeyValuePair
              name="Batches"
              keyElement={<Typography variant="overline">Batches</Typography>}
              valueElement={
                <Typography variant="h6" component="div" lineHeight={1}>
                  {batches}
                </Typography>
              }
              gap={1}
            />
          </Box>
          <Divider orientation="vertical" variant="middle" flexItem />
        </>
      )}
      <Box p={2}>
        <KeyValuePair
          name="Estimated Runtime"
          keyElement={
            <Typography variant="overline">Estimated Runtime</Typography>
          }
          valueElement={
            <Typography variant="h6" component="div" lineHeight={1}>
              {formattedTime}
            </Typography>
          }
          gap={1}
        />
      </Box>
    </Stack>
  );
};

export default PreviewMetrics;
